module.exports = __webpack_public_path__ + "static/media/maze-bacground.de0dbd06.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/maze-bacground.svg
// module id = 1796
// module chunks = 0